const appContent = {
  data() {
    return {
      initHideTravel: false,
      filterLarge: true,
      filterType: false,
      filterSkin: false,
      filterConcern: false,
      filterOpen: false,
      modalOpen: false,
      renderKey: 0,
      filterParam: null,
      mobileWidth: 767,
      mobileView: false,
      viewHeight: 0,
      viewWidth: 0,
      newSwitch: false,
      saleSwitch: false,
      holidaySwitch: false,
      dotdSwitch: false,
      dotdOn: false,
      filtersCollaped: true,
      selected: [],
      filter: []
    }
   },
   watch: {
    filterSkin(newVal, oldVal) {
      this.filtersCollaped = !newVal && !this.filterType && !this.filterConcern;
    },
    filterConcern(newVal, oldVal) {
      this.filtersCollaped = !this.filterSkin && !this.filterType && !newVal;
    },
    filterType(newVal, oldVal) {
      this.filtersCollaped = !this.filterSkin && !newVal && !this.filterConcern;
    },
    viewWidth(newVal, oldVal) {
      this.mobileView = newVal <= this.mobileWidth;
    },
    mobileView(newVal, oldVal) {
      let wasMobile = oldVal;
      let isMobile = newVal;
      if (isMobile && !wasMobile && this.filterOpen) this.filterSwap(true);
      if (!isMobile && wasMobile && this.modalOpen) this.filterSwap(false);
    }
  },
   methods: {
    filterSwap(isMobile) {    
      if (isMobile) { // swap open desktop filter to mobile modal
        this.openCloseFilter(); // this.filterOpen = false;
        setTimeout(() => {
          this.openCloseFilterMobile('show'); // this.modalOpen = true;
        }, 1);
      } else { // swap open mobile modal to desktop filter
        $('#modal-filter-mobile').modal('hide'); // this.modalOpen = false;
        this.forceRerender();
        setTimeout(() => {
          this.openCloseFilter('filterType', true); // this.filterOpen = true;
          this.openCloseFilter('filterSkin', true);
          this.openCloseFilter('filterConcern', true);
        }, 1);
      }
    },
    initTravel(hide) {
      if (this.initHideTravel) return;

      let onlyInit = false;
      if (window.location.href.indexOf("/all/product") > -1) onlyInit = true;
      if (window.location.href.indexOf("?filter=") > -1) onlyInit = true;
      
      if (hide && !onlyInit) {
        Array.from(document.querySelectorAll('.grid__item[data-tags]')).forEach( product => {
          if (product.dataset.tags.includes("productTravel")) {
            $(product).hide().removeClass('aos-animate');
          }
          if (product.dataset.tags.includes("init-travel-ready")) {
            $(product).show().addClass('aos-animate');
          }
        });
      } else {
        this.initHideTravel = false;
        Array.from(document.querySelectorAll('.grid__item[data-tags]')).forEach( product => {
          if (!onlyInit && product.dataset.tags.includes("productTravel")) {
            $(product).show().addClass('aos-animate');
          }
          if (product.dataset.tags.includes("init-travel-ready")) {
            $(product).hide().removeClass('aos-animate');
          }
        });
      }
      
    },
    openCloseFilter(filter, toggle) {
      const highestHeight = document.querySelector('.wrapper-filterType').clientHeight;
      this.filterLarge = true;

      if (filter) {
        this[filter] = toggle || !this[filter];
        if(!this.filterOpen) this.filterOpen = true;
        $(`.wrapper-${filter}`).closest('.filter-items-wrapper').height(this[filter] ? highestHeight : 0);
        $('.wrapper-filterStatus').closest('.filter-items-wrapper').height(highestHeight);
      } else {
        this.filterOpen = !this.filterOpen;
        if (this.filterOpen) {
          $('.wrapper-filterStatus').closest('.filter-items-wrapper').height(highestHeight);
          this.doFilter();
          if(this.selected.length) {
            $('.filter-items-wrapper').height(this.clientHeight);
            this.filterConcern = true;
            this.filterType = true;
            this.filterSkin = true;
            this.filtersCollaped = false;
          }
        } else {
          this.clientHeight = document.querySelector('.wrapper-filterType').clientHeight;
          $('.filter-items-wrapper').height(0);
          if(this.selected.length) this.filterLarge = false;
          this.filterConcern = false;
          this.filterType = false;
          this.filterSkin = false;
          this.filtersCollaped = true;
        }
      }
    },
    doRedirect(event) {
      window.location = event;
    },
    doFilter(event) {
      if (typeof isSeasonalFiltered == "function") isSeasonalFiltered(this.holidaySwitch); //snippets\collection-hero-new-year-skin-kits.liquid

      let isTravel = this.selected.filter(s => s.indexOf('type_filter|producttravel ready') > -1);
      if (typeof isTravelReadyFiltered == "function") isTravelReadyFiltered(isTravel); //snippets\collection-hero-winter-vacation-skincare.liquid

      this.initTravel(false);
      
      $('.grid__item[data-tags]').hide().removeClass('aos-animate');
      // DO THE FILTERS
      this.filter = Array.from(document.querySelectorAll('.grid__item[data-tags]'))
                        .filter(product => {
                          let selected_skin = this.selected.filter(s => s.indexOf('skin') > -1);
                          const re = new RegExp(selected_skin.join("|").toUpperCase(), 'g');
                          return product.dataset.tags && product.dataset.tags.toUpperCase().match(re)
                        })
                        .filter(product => {
                          let selected_type = this.selected.filter(s => s.indexOf('type') > -1);
                          const re = new RegExp(selected_type.join("|").toUpperCase(), 'g');
                          return product.dataset.tags && product.dataset.tags.toUpperCase().match(re)
                        })
                        .filter(product => {
                          let selected_concern = this.selected.filter(s => s.indexOf('concern') > -1);
                          const re = new RegExp(selected_concern.join("|").toUpperCase(), 'g');
                          return product.dataset.tags && product.dataset.tags.toUpperCase().match(re)
                        })
                        .filter(product => {
                          let selected_status = this.selected.filter(s => s.indexOf('status') > -1);
                          const re = new RegExp(selected_status.join("|").toUpperCase(), 'g');
                          return product.dataset.tags && product.dataset.tags.toUpperCase().match(re)
                        })
    
      
      //SET SELECTED
      event && $(event.target).closest('.btn-filter-item').toggleClass('activated');

      // FIX FILTER HEIGHT (setTimeout() used here to wait to complete the animation)
      setTimeout(() => {
        if(! this.selected.filter(s => s.indexOf('status') === -1).length) return;
        if(! this.filterLarge) return;
        if(this.mobileView) return;
        const highestHeight = document.querySelector('.wrapper-filterType').clientHeight;
        $('.filter-items-wrapper').height(highestHeight);
      }, 200)

      // SHOW ALL
      this.filter.forEach( product => { $(product).show().addClass('aos-animate'); })
      console.log(`${this.filter.length} products`);
    }, 
    clearFilter() {
      if(this.filterParam) {
        window.location.search = '';
      } else {
        this.filterLarge = true;
        this.filterOpen = false;
        this.filterConcern = false;
        this.filterType = false;
        this.filterSkin = false;
        $('.filter-items-wrapper').height(0);
        $('.filters input:checked').each(function () { $(this).trigger('click'); });
      }
      this.mobileView && this.openCloseFilterMobile('hide');
    },
    removeFilter(filter) {
      $(`input[value="${filter}"]`).trigger('click');
      !this.selected.length && this.clearFilter();
    },
    openCloseFilterMobile(action) {
      const open = !!this.selected.length;
      this.changeCollapsedFilters(open, 'mobile');
      if (action == 'show') {
        $('#modal-filter-mobile').on('hidden.bs.modal', this.onModalClose);
        this.modalOpen = true;
      }
      $('#modal-filter-mobile').modal(action);
    },
    changeCollapsedFilters(openFilters, mobile) {
      if(openFilters) {
        $('#filter-mobile-accordion .filters').find('button').removeClass("collapsed")
        $('#filter-mobile-accordion .filters').find('.accorion-content').addClass("show");
        this.filtersCollaped = false;
      } else {
        $('#filter-mobile-accordion .filters').find('button').addClass("collapsed")
        $('#filter-mobile-accordion .filters').find('.accorion-content').removeClass("show");
        this.filtersCollaped = true;
      }
      if(!mobile) {
        if (!openFilters) {
          this.filterType = true; // openCloseFilter just flips...
          this.filterSkin = true; // openCloseFilter just flips...
          this.filterConcern = true; // openCloseFilter just flips...
        }
        this.openCloseFilter('filterType', openFilters);
        this.openCloseFilter('filterSkin', openFilters);
        this.openCloseFilter('filterConcern', openFilters);
      }
    },
    getSelectedByFilterType(type) {
      return this.selected.filter(s => s.indexOf(type) > -1);
    },
    onResize() {
      this.viewWidth = window.innerWidth;
      this.viewHeight = window.innerHeight;
    },
    onModalClose() {
      this.modalOpen = false;
    },
    forceRerender() {
      this.renderKey += 1;
    }
   },
   created () {
    window.addEventListener('resize', this.onResize);
    this.onResize();

    $(document).ready(() => {
      this.filterParam = new URLSearchParams(window.location.search).get("filter");
      if(this.filterParam) {
        this.filterLarge = false;
        if($(`input#filter-${this.filterParam}`).length) {
          $(`input#filter-${this.filterParam}`).trigger('click');
        }
        else {
          window.location.assign('/collections/all')
        }
      }
    })

    // Check if there's a deal of the day
    this.dotdOn = !!Array.from(document.querySelectorAll('.grid__item[data-tags]')).filter(product => product.dataset.tags.indexOf('deal of the day') > 1).length;
    
    
    // SHOW FILTER WHEN APP IS LOADED
    document.querySelector('#filter').classList.remove('d-none')

    this.initTravel(true);
    
   }

}
const app = new Vue(appContent)
app.$mount('#filter-app');

